import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=98334534&"
import script from "./AddToCart.vue?vue&type=script&lang=js&"
export * from "./AddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiCardHolder: require('/data/www/buyanygiftcard.com/buyanygiftcard/nuxt/components/ui/CardHolder/index.vue').default,IconsChevronRight: require('/data/www/buyanygiftcard.com/buyanygiftcard/nuxt/components/icons/ChevronRight.vue').default,UiButtonsButtonPrimary: require('/data/www/buyanygiftcard.com/buyanygiftcard/nuxt/components/ui/Buttons/ButtonPrimary.vue').default,Modal: require('/data/www/buyanygiftcard.com/buyanygiftcard/nuxt/components/base/Modal.vue').default})
